module.exports = __webpack_public_path__ + "0bb7154f24338832e4b96907a69cc740.svg";